import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "EN" },
  { code: "pl", label: "PL" },
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = languages.find((l) => l.code === i18n.language) || languages[0];

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/70 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 cursor-pointer"
        aria-label="Change language"
      >
        <span className="w-4 h-4 flex items-center justify-center text-foreground-700">
          <i className="ri-global-line"></i>
        </span>
        {current.label}
        <span className="w-4 h-4 flex items-center justify-center text-foreground-500">
          <i className={open ? "ri-arrow-up-s-line text-xs" : "ri-arrow-down-s-line text-xs"}></i>
        </span>
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-32 overflow-hidden rounded-lg border border-background-300/70 bg-background-50 py-1">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between whitespace-nowrap px-3 py-2 text-sm transition-colors cursor-pointer ${
                l.code === i18n.language
                  ? "bg-primary-50 font-semibold text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              {l.label}
              {l.code === i18n.language && (
                <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-check-line text-sm"></i>
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}